import Internet from '@spa/shared/svg/internet';
import NoInternet from '@spa/shared/svg/no-internet';
import Electricity from '@spa/shared/svg/electricity';
import NoElectricity from '@spa/shared/svg/no-electricity';
import Gas from '@spa/shared/svg/gas';
import NoGas from '@spa/shared/svg/no-gas';
import Water from '@spa/shared/svg/water';
import NoWater from '@spa/shared/svg/no-water';

export const GLOBAL_BILLS = {
  internet: {
    Component: Internet,
    translation: 'global_bills.internet'
  },
  'no-internet': {
    Component: NoInternet,
    translation: 'global_bills.internet'
  },
  electricity: {
    Component: Electricity,
    translation: 'global_bills.electricity'
  },
  'no-electricity': {
    Component: NoElectricity,
    translation: 'global_bills.electricity'
  },
  gas: {
    Component: Gas,
    translation: 'global_bills.gas'
  },
  'no-gas': {
    Component: NoGas,
    translation: 'global_bills.gas'
  },
  water: {
    Component: Water,
    translation: 'global_bills.water'
  },
  'no-water': {
    Component: NoWater,
    translation: 'global_bills.water'
  }
};
